<template>
  <a class="text-decoration-none text-capitalize" @click="goToMentorProfile()" :style="{ color }">
    {{ getDisplayNameOrEmail(user) }}
    <v-icon v-if="isMentorApproved" class="px-0 py-0 mt-0" color="green" small>mdi-check-decagram</v-icon>
  </a>
</template>

<script>
import {getDisplayNameOrEmail} from "@/utilz/dispalyNameOrEmail";

export default {
  name: "ProfileNameOrUserName",
  props: {
    user: {
      type: Object,
      default: () => ({profile: {}, username: "", uuid: ""})
    },
    color: {
      type: String,
      default: undefined
    }
  },
  computed: {
    isMentorApproved() {
      return this.user.profle?.status?.toUpperCase() === "APPROVED";
    }
  },
  methods: {
    goToMentorProfile() {
      this.user.uuid && this.$router.push(`/mentors/${this.user.uuid}`)
    },
    getDisplayNameOrEmail(user) {
      return getDisplayNameOrEmail(user);
    },
  }
}
</script>

<style scoped>
.change-cursor {
  cursor: pointer !important;
}
</style>
